import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { updateTimerNode } from "../../../../state/undoFlow/actions";

import {
  Header,
  Container,
  Description,
  TimerInput,
  InputContainer,
  Label,
} from "./styles";

import Popper from "../../../general/Popper";
import TimerPopperIcon from "../../../../assets/icons/TimerPopperIcon";

const TimerPopper = ({ id, className, isOpen, onClose, data, anchorRef }) => {
  const [deadline, setDeadLine] = useState(data.expiration.number / 24);

  const errorStyle = {
    border: "0.941243px solid red",
  };

  const dispatch = useDispatch();

  const [markerPosition, setMarkerPosition] = useState({
    pos: `50%`,
    above: true,
  });

  const timerValidation = () => {
    if (data.expiration.number / 24 === deadline) {
      return false;
    } else if (deadline < 1) {
      setDeadLine(data.expiration.number / 24);
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (!isOpen) {
      if (timerValidation()) {
        setDeadLine(data.expiration.number / 24);
      }
    }
  }, [isOpen, data]);

  useEffect(() => {
    if (timerValidation()) {
      dispatch(
        updateTimerNode({
          id,
          deadline: deadline,
        })
      );
    }
  }, [isOpen]);

  const handleChange = (e) => setDeadLine(e.target.value);

  return (
    <Popper
      isOpen={isOpen}
      onClose={onClose}
      anchorRef={anchorRef}
      width={280}
      height={150}
      setMarkerPosition={setMarkerPosition}
      markerSize={14}
    >
      <Container
        markPosition={markerPosition.pos}
        isAbove={markerPosition.above}
      >
        <Header>
          <TimerPopperIcon />
          <span>Editar Temporizador</span>
        </Header>
        <Description>
          Defina o tempo para iniciar a próxima tarefa do fluxo:
        </Description>
        <InputContainer>
          <TimerInput
            value={deadline}
            onChange={handleChange}
            type="number"
            min="1"
            max="999"
          />
          <Label>Dias</Label>
        </InputContainer>
      </Container>
    </Popper>
  );
};

export default TimerPopper;
